import { RandomId } from "@swivl-mono/helpers";
import { NodeInterface } from "@swivl-mono/types";

import TabNodeLayoutData from "../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "./NodePanel";

const TypingIndicator = {
  Type: "typingIndicator",
  Empty: function () {
    return {
      id: RandomId(6),
      type: TypingIndicator.Type,
      onCompleteGoto: null
    };
  },

  PlumbData: function (node: NodeInterface) {
    return TabNodeLayoutData({
      node: node,
      label: "Typing",
      baseWidth: 120,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: node.onCompleteGoto }]
    });
  },

  InspectorPanel: class SaveInspectorPanel extends NodePanel {
    render() {
      return (
        <div className="panel save_panel">
          <InspectorNodeHeader title="Typing Indicator" id={this.props.node.id} />

          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};
export default TypingIndicator;
